import { ChangeEvent } from 'react';

import {
  FieldValues,
  FilterFormProps,
  MultipleBooleanFilterProps,
} from '@/models/FilterConfig';
import { FilterPopup } from './FilterPopup';
import FilterHeader from './FilterHeader';
import CheckGroup, {
  CheckOption,
} from '@/components/ui/custom/dataInput/CheckGroup';

export default function MultipleBooleanFilter(
  props: MultipleBooleanFilterProps & FilterFormProps,
) {
  const { label, options, setValue, values = [], setValues } = props;

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { checked } = e.target;
    setValue(e.target.value, checked || undefined);
  };

  async function onClear() {
    const reduceNames = options.reduce((previousValue, currentValue) => {
      previousValue[currentValue.name] = undefined;

      return previousValue;
    }, {} as FieldValues);

    setValues?.(reduceNames);
  }

  const optionsGroup: CheckOption[] = options.map(({ name, label }) => ({
    id: name,
    value: name,
    label,
    checked: values.includes(name),
  }));

  return (
    <FilterPopup
      label={label}
      reference={<FilterHeader label={label} notifications={values.length} />}
      onClear={values.length ? onClear : undefined}
    >
      <CheckGroup options={optionsGroup} onChange={handleChange} />
    </FilterPopup>
  );
}
